module.exports = __webpack_public_path__ + "img/cause3Blue.cec10e75.png";